<template>
<div>
    <div class="row">
        <div class="col-10 col-md-6">
            <h2 class="text-primary" style="margin-bottom: 0px;">
                <i class="fas fa-building" /> Minha Empresa
            </h2>
            <small class="text-muted">Controle os dados da sua empresa.</small>
        </div>
    </div>
    <br />

    <div class="row">
        <div class="col-md-6">
            <div class="card mb-4">
                <div class="card-body">
                    <div class="row d-flex align-items-center">
                        <div class="col-10 col-md-6">
                            <h5 class="mb-0 text-primary">
                                <i class="fas fa-building" /> Informaçoes
                            </h5>
                        </div>
                        <div class="col-2 col-md-6 text-right">
                            <button class="btn btn-sm btn-success" style="margin-left:5px" @click="updateCompany()">
                                <i class="fas fa-pen" />
                                <span class="d-none d-lg-inline"> Editar Informações</span>
                            </button>
                        </div>
                    </div>
                    <hr />
                    <!-- DADOS DA EMPRESA -->
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="text-primary">
                                <i class="fas fa-address-card" /> Dados da empresa
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Razão Social:</small>
                        </div>
                        <div class="col-md-8">{{ company.name | ucfirst }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Nome Fantasia:</small>
                        </div>
                        <div class="col-md-8">{{ company.alias | ucfirst }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Cnpj:</small>
                        </div>
                        <div class="col-md-8">{{ company.cnpj }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Inscrição Estadual:</small>
                        </div>
                        <div class="col-md-8">{{ company.inscricao_estadual }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Inscrição Municipal:</small>
                        </div>
                        <div class="col-md-8">{{ company.inscricao_municipal }}</div>
                    </div>

                    <br />
                    <br />

                    <!-- ENDEREÇO -->
                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="text-primary">
                                <i class="fas fa-map-marked-alt" /> Endereço
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Endereço:</small>
                        </div>
                        <div class="col-md-8">{{ company.address }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Numero:</small>
                        </div>
                        <div class="col-md-8">{{ company.number }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Complemento:</small>
                        </div>
                        <div class="col-md-8">{{ company.complement }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Bairro:</small>
                        </div>
                        <div class="col-md-8">{{ company.district }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">CEP:</small>
                        </div>
                        <div class="col-md-8">{{ company.zipcode }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Cidade - Estado:</small>
                        </div>
                        <div class="col-md-8">{{ company.city }} - {{ company.state }}</div>
                    </div>

                    <br />
                    <br />

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="text-primary">
                                <i class="fas fa-phone-alt" /> Contatos
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Telefones:</small>
                        </div>
                        <div class="col-md-8">{{ company.phone_wa }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <!--<small class="text-muted">Telefone:</small>-->
                        </div>
                        <div class="col-md-8">{{ company.phone2 }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <!--<small class="text-muted">Telefone:</small>-->
                        </div>
                        <div class="col-md-8">{{ company.phone3 }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <!--<small class="text-muted">Telefone:</small>-->
                        </div>
                        <div class="col-md-8">{{ company.phone4 }}</div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Emails:</small>
                        </div>
                        <div class="col-md-8">{{ company.email1 }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <!--<small class="text-muted">Telefone:</small>-->
                        </div>
                        <div class="col-md-8">{{ company.email2 }}</div>
                    </div>

                    <br />

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Site:</small>
                        </div>
                        <div class="col-md-8">{{ company.website }}</div>
                    </div>

                    <br />
                    <br />

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="text-primary">
                                <i class="fas fa-file-invoice" /> Informações Fiscais
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Cnae:</small>
                        </div>
                        <div class="col-md-8">{{ company.cnae }}</div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <small class="text-muted">Código de Regime Tributário:</small>
                        </div>
                        <div class="col-md-8">{{ company.crt }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="row d-flex align-items-center">
                        <div class="col-10 col-md-6">
                            <h5 class="mb-0 text-primary">
                                <i class="fas fa-id-card" /> Certificado Digital
                            </h5>
                        </div>
                        <div class="col-2 col-md-6 text-right">
                            <button class="btn btn-sm btn-success" style="margin-left:5px" @click="openCertificateForm()">
                                <i class="fas fa-upload" />
                                <span class="d-none d-lg-inline"> Enviar Certificado</span>
                            </button>
                        </div>
                    </div>
                    <hr />
                    <template v-if="company.certificate != null">
                        <div class="row d-flex justify-content-center" >
                            <div class="row grid-table-heading">
                                <table >
                                    <tr>
                                        <td class="col-md-2 text-middle text-muted">Nome do Arquivo:</td>
                                        <td class="col-md-2 text-middle text-muted">Emissão:</td>
                                        <td class="col-md-2 text-middle text-muted">Validade:</td>
                                    </tr>
                                    <tr v-for="row in company.certificate" :key="row.id">
                                        <template v-if="row.status != 0">
                                        <td class="col-md-2 text-middle">{{ row.original_file_name }}</td>
                                        <td class="col-md-2 text-middle">{{ row.valid_from_date | dateBr}}</td>
                                        <td class="col-md-2 text-middle">{{ row.valid_to_date | dateBr }}</td>
                                        <td class="col-md-2 text-middle"><button class="btn btn-link" @click="openDeleteCertificateForm(row)"><i class="fas fa-trash" /></button></td>
                                        </template>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <br />
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-12">
                        <div class="card-body">
                            <div class="row d-flex align-items-center">
                                <div class="col-10 col-md-6">
                                    <h5 class="mb-0 text-primary">
                                        <i class="fas fa-receipt" /> Configurar NF-e
                                    </h5>
                                </div>
                                <div class="col-2 col-md-6 text-right">
                                    <button class="btn btn-sm btn-success" style="margin-left:5px" @click="openCompanyNfeConfigForm()">
                                        <i class="fas fa-pen" />
                                        <span class="d-none d-lg-inline"> Editar Configurações</span>
                                    </button>
                                </div>
                            </div>
                            <br />
                            <hr />

                            <!-- Dados configurar-->

                            <div class="row">
                                <div class="col-md-8">
                                    <small class="text-muted">CSC - Código de segurança do contribuinte:</small>
                                </div>
                                <div class="col-md-8">{{ company.csc }}</div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-8">
                                    <small class="text-muted">(ID) do contribuinte no banco de dados da SEFAZ</small>
                                </div>
                                <div class="col-md-8">{{ company.csc_id }}</div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-8">
                                    <small class="text-muted">Ambiente de emissão NF:</small>
                                </div>
                                <div class="col-md-8">{{ ambiente[company.ambiente_nfe] }}</div>
                            </div>

                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <company-form ref="companyForm" @stored="select($event)" />

        <certificate-form ref="certificateForm" @stored="select($event)" />

        <company-nfe-config-form ref="companyconfigForm" @stored="select($event)" />

        <confirm-delete-certificate-form ref="confirmDeleteCertificateForm" @stored="select($event)"/>
    </div>
</div>
</template>

<script>
import CompanyForm from "./../components/forms/CompanyForm.vue";
import CertificateForm from "./../components/forms/CertificateForm.vue";
import CompanyNfeConfigForm from "./../components/forms/CompanyNfeConfigForm.vue";
import Form from "./../mixins/Form.js";
import Filters from "./../mixins/Filters.js";
import ConfirmDeleteCertificateForm from "./../components/forms/ConfirmDeleteCertificateForm.vue";

export default {

    components: {
        CompanyForm,
        CertificateForm,
        CompanyNfeConfigForm,
        ConfirmDeleteCertificateForm
    },

    data: function () {
        return {
            id: null,
            path: null,
            company: {},
            ambiente: {
                1: "Ambiente de produção",
                2: "Ambiente de homologação"
            }
        };
    },

    mounted() {
        axios
            .post("api/company/select")
            .then(response => {
                this.company = response.data;

                this.$store.commit("pageHasLoaded");
            })
            .catch(error => {
                this.error = error;

                //this.$store.commit('pageHasLoadedWithError', {error : error})
            });
    },

    computed: {},

    methods: {

        select() {
            axios
                .post("api/company/select")
                .then(response => {
                    this.company = response.data;

                    this.$store.commit("pageHasLoaded");
                })
                .catch(error => {
                    this.error = error;

                    //this.$store.commit('pageHasLoadedWithError', {error : error})
                });

        },

        updateCompany() {
            this.$refs.companyForm.open(this.company);
        },

        refreshCompany(newValues) {
            this.company = newValues;
        },

        refreshCompanyNfeConfig() {},

        openCertificateForm() {
            this.$refs.certificateForm.open();
        },

        openCompanyNfeConfigForm() {
            this.$refs.companyconfigForm.open(this.company);
        },

         openDeleteCertificateForm(row) {
            this.$refs.confirmDeleteCertificateForm.open(row);
        }

        // deleteCertificate(id, path) {

        //     this.$store.commit("showLoading");

        //     let form = new FormData();

        //     form.append("id", id);
        //     form.append("path", path);

        //     axios
        //         .post("api/certificate/delete", form)
        //         .then(response => {

        //             this.select();
        //             this.$store.commit("hideLoading");
        //             this.$store.commit("showAlert", {
        //             message: "Certificado Excluido com sucesso!",
        //             type: "Success"
        //     });
        //         })
        //         .catch(error => {
        //             console.log(error)
        //             this.error = error;
        //             this.$store.commit("hideLoading");
        //         });

        // },
    }
};
</script>
